import script from "./CategoryNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./CategoryNew.vue?vue&type=script&lang=ts&setup=true"

import "./CategoryNew.vue?vue&type=style&index=0&id=4892dd3c&lang=css"

const __exports__ = script;

export default __exports__